/**
 * @author WYX
 * @date 2019/12/25
 * @Description: 头条号视频稿件
 */
'use strict';
angular.module('editingCenterToutiaohaoVideoModule', []).controller('editingCenterToutiaohaoVideoCtrl', [
    '$scope',
    '$state',
    '$q',
    '$element',
    '$compile',
    'toutConst',
    'trsHttpService',
    'beforeonload',
    'toutiaohaoService',
    'editingMediatype',
    'messagePublishService',
    'editIsLock',
    function (
        $scope,
        $state,
        $q,
        $element,
        $compile,
        toutConst,
        trsHttpService,
        beforeonload,
        toutiaohaoService,
        editingMediatype,
        messagePublishService,
        editIsLock
    ) {
        initStatus();
        initData();
        toutiaohaoService.addFuture($scope, ['sendmessage']);
        
        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            // 额外注意
            $scope.tipsUse = {
                // 为false的时候不显示文章分类
                isShowType: false,
            };
            // 需要多指令调用的status
            $scope.parentStatus = {
                // 稿件信息和流程版本切换，默认稿件信息
                switch: 'manuscriptInfo',
                // 是否待修订
                isawaitrevise: !!$state.params.isawaitrevise,
                // 正文（暂时放在这，因为其他部分有可能会用）
                zhengwen: false,
                // 获取媒体类型
                mediaType: editingMediatype.toutiaohao,
                // 获取articleid
                articleid: $state.params.articleid,
                // 是否来自融合编辑器
                isFusionEditor: $state.current.name === 'fusionvideo',
                // 渠道名称
                mediaName: 'toutiaohao',
                // 编辑列表刷新监听名称
                ListListener: 'addListenerToToutiaohao',
                // 头条号基础请求配置
                typeConst: toutConst,
                // 表单校验失败信息（为了融合编辑）
                formErrorMsg: {
                    plat: '头条号'
                }
            };
            $scope.parentStatus.typeConst.sign = $state.params.platform === '1' ? $scope.parentStatus.typeConst.signOfDaishen : $scope.parentStatus.typeConst.signOfDaibian;
            $scope.parentData = {
                // 表单名称
                formName: 'tthVideoForm',
                // 最近一个版本的id在编辑器和在获取融合编辑使用
                lastVersionid: '',
                // 稿件来源管理
                originType: '',
                // 选择文章分类
                articleClass: {},
                // 标签数组
                LABEL: [],
                //
                specialDoc: null,
                
            };
            $scope.data = {
                trench: toutConst.listenStroageKey,
            };
            // 请求参数集中配置
            $scope.httpUrl = {
                // 融合编辑保存接口参数
                virtualSaveVideo: {
                    serviceid: 'mlf_fusiontoutiao',
                    methodName: 'saveTouTiaoVirtualVideoDoc',
                    SourceDocId: $state.params.iwometadataid || $state.params.articleid, // 需要修改
                    FusionToutiaoId: $state.params.articleid || '0',
                },
                // 视频编辑以及保存
                saveVideo: {
                    serviceid: 'mlf_toutiao',
                    methodName: 'saveVideoDoc',
                    // 稿件id
                    METADATAID: 0,
                    // 指定频道
                    CHANNELID: $state.params.account,
                    // 是否进行手动提交
                    EDITABLE: '0',
                },
                // 获取稿件信息
                getVideo: {
                    serviceid: 'mlf_toutiao',
                    methodName: 'getTouTiaoArticle',
                    // 稿件id
                    METADATAID: $state.params.articleid,
                    // 指定频道
                    CHANNELID: $state.params.account,
                },
                // 请求基础参数
                baseParam: getBaseParam(),
            };
            $scope.footFunc = ['save'];
            // 编辑表单
            $scope.list = {};
            $scope.element = $element;
            $scope.compile = $compile;
            $scope.editFlag = {
                media: 'toutiaohao', 
                docType: 'video',
            };
        }

        /**
         * [getBaseParam 获取基础参数]
         *
         * @return  {[type]}  [return description]
         */
        function getBaseParam(){
            return {
                // 指定频道
                METADATAIDS: $state.params.articleid,
                // 稿件ids
                CHANNELID: $state.params.account,
            };
        }

        /**
         * [afterSaveList description]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.afterSaveList = function(data){
            $scope.httpUrl.baseParam.METADATAIDS = data.METADATAID;
        };

        /** **************************适应融合编辑器切换渠道开始**************************/
        /**
         * [initData description]初始化数据
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]
         * @return  {[type]}                   [return description]
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if (angular.isDefined($state.params.articleid)) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /** **************************适应融合编辑器切换渠道结束**************************/

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            initFootFunction();
            // 判断是不是融合编辑器后初始化数据以及注册关闭编辑器事件
            if (!$scope.parentStatus.isFusionEditor) {
                initArrayBtn();
                ($state.params.articleid ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
        }

        /**
         * [initArrayBtn description]初始化底部操作按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            toutiaohaoService.initEditerBtn($state.params.platform, $state.params.account).then(function(data) {
                $scope.arrayBtn = data;
            });
        }

        /**
         * [initArrayBtn description]调用foot方法message传递处理
         * @return {[type]} [description]
         */
        function initFootFunction() {
            $scope.footFunc.forEach((item) => {
                $scope[item] = function () {
                    var defer = $q.defer();
                    messagePublishService.publish(`${$scope.parentStatus.mediaName}${item}`, '');
                    messagePublishService.subscribe(`${$scope.parentStatus.mediaName}${item}Over`, function (check, data) {
                        if (data) {
                            defer.resolve();
                        } else {
                            defer.reject($scope.parentStatus.formErrorMsg);
                        }
                    });
                    return defer.promise;
                };
            });
        }

        /**
         * [initNewData description]初始化新稿件
         * @param   {[Function]}  dealWithListFun  [dealWithListFun description]传入的方法
         * @return  {[type]}                   [return description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            if ($scope.parentStatus.isFusionEditor) {
                $scope.list = angular.extend($scope.httpUrl.virtualSaveVideo, toutiaohaoService.getList());
            } else {
                $scope.list = angular.extend($scope.httpUrl.saveVideo, toutiaohaoService.getList());
            }
            messagePublishService.publish(`${$scope.parentStatus.mediaName}ListInit`, '');
            // 融合编辑器下转码list
            if ($scope.parentStatus.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            defer.resolve();
            return defer.promise;
        }

        /**
         * [initNewData description]初始化编辑稿件
         * @param   {[Function]}  dealWithListFun  [dealWithListFun description]传入的方法
         * @return  {[type]}                   [return description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            var params = {};
            // 适应融合编辑
            if ($scope.parentStatus.isFusionEditor) {
                params = {
                    serviceid: 'mlf_fusiontoutiao',
                    methodname: 'getTouTiaoVirtualDoc',
                    SourceDocId: $state.params.iwometadataid,
                    FusionTouTiaoId: $state.params.articleid,
                };
            } else {
                params = $scope.httpUrl.getVideo;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                document.title = data.TITLE;
                $scope.parentData.remarks = data.REMARKS;
                if ($scope.parentStatus.isFusionEditor) {
                    $scope.list = angular.extend($scope.httpUrl.virtualSaveVideo, data);
                } else {
                    $scope.list = angular.extend($scope.httpUrl.saveVideo, data);
                }
                $scope.list.TOPATTACHFILE = [];
                // 融合编辑下转码list
                if ($scope.parentStatus.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                messagePublishService.configPublish(`${$scope.parentStatus.mediaName}ListInit`, true); // 由于原来的消息/订阅进行了修改，这里解决传输配置项的方式（同时多个一起）来解决接收不到订阅消息的问题
                messagePublishService.publish(`${$scope.parentStatus.mediaName}VersionInit`);
                defer.resolve();
            });
            //  稿件加锁
            editIsLock.lockDraft($state.params.articleid);
            return defer.promise;
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.tthVideoForm.$error) {
                errorArray.push(error);
            }
            $scope.parentStatus.videoFormError = $scope.parentStatus.videoFormError == undefined ? [] : $scope.parentStatus.videoFormError;
            if ($scope.parentStatus.videoFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.parentStatus.videoFormError = errorArray;
            }
            return $scope.parentStatus.videoFormError; // 返回
        };

        /**
         * [theFormError description] 改变是否是否手动提交
         * @param   {[object]}  list 传入list
         * @return {[type]} [description]
         */
        $scope.EDITABLESelection = function (list) {
            list.EDITABLE = list.EDITABLE === '1' ? '2' : '1';
        };
    },
]);
